/**
 * File: quoteModal.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.2
 * Created: 2026-01-06
 * Last Updated: 2026-07-26
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Contact Modal
export const quoteModal = {
    id: "quote-modal",
    formHeader: {
        header: "Custom Project Estimate",
        subheader:
            "Share your vision with us and receive a detailed quote within 48 hours.",
    },
    headers: {
        contactInformation: "1. Contact Information",
        serviceSelection: "2. Service Selection",
        services: "Services",
        disciplines: "Disciplines",
        projectDetails: "3. Project Details",
    },
    textField: {
        companyName: {
            label: "Company Name",
        },
        firstName: {
            label: "First Name",
        },
        lastName: {
            label: "Last Name",
        },
        city: {
            label: "City",
        },
        scope: {
            label: "Scope of Work",
        },
    },
    checkList: {
        services: {
            heading: "Services",
            checkboxes: [
                {
                    id: "quote-service-site-surveying",
                    label: "Site Surveying",
                },
                {
                    id: "quote-service-drafting",
                    label: "Drafting",
                },
                {
                    id: "quote-service-engineering",
                    label: "Engineering",
                },
                {
                    id: "quote-service-qaqc-review",
                    label: "QAQC Review",
                },
            ],
        },
        disciplines: {
            heading: "Disciplines",
            checkboxes: [
                {
                    id: "quote-discipline-mechanical",
                    label: "Mechanical",
                },
                {
                    id: "quote-discipline-plumbing",
                    label: "Plumbing",
                },
            ],
        },
    },
    stateField: {
        label: "State",
    },
    dropDownField: {
        package: {
            label: "Package",
            options: [
                {
                    id: "quote-package-basic",
                    value: "Basic",
                },
                {
                    id: "quote-package-standard",
                    value: "Standard",
                },
                {
                    id: "quote-package-premium",
                    value: "Premium",
                },
            ],
        },
        timeline: {
            label: "Timeline",
            options: [
                {
                    id: "quote-timeline-asap",
                    value: "ASAP (1–3 days)",
                },
                {
                    id: "quote-timeline-1-week",
                    value: "Within 1 week",
                },
                {
                    id: "quote-timeline-1-2-weeks",
                    value: "1–2 weeks",
                },
                {
                    id: "quote-timeline-2-4-weeks",
                    value: "2–4 weeks",
                },
                {
                    id: "quote-timeline-1-2-months",
                    value: "1–2 months",
                },
                {
                    id: "quote-timeline-3-plus-months",
                    value: "3+ months",
                },
                {
                    id: "quote-timeline-unsure",
                    value: "Not sure yet",
                },
            ],
        },
        type: {
            label: "Type",
            options: [
                {
                    id: "quote-residential",
                    value: "Residential",
                },
                {
                    id: "quote-commercial",
                    value: "Commercial",
                },
                {
                    id: "quote-industrial",
                    value: "Industrial",
                },
                {
                    id: "quote-healthcare",
                    value: "Healthcare",
                },
                {
                    id: "quote-mixed-use",
                    value: "Mixed-Use",
                },
                {
                    id: "quote-other",
                    value: "Other",
                },
            ],
        },
        size: {
            label: "Total Floor Area (All Levels)",
            options: [
                {
                    id: "quote-size-0–4999",
                    value: "0–4,999 ft²",
                },
                {
                    id: "quote-size-5000–9999",
                    value: "5,000–9,999 ft²",
                },
                {
                    id: "quote-size-10000–24999",
                    value: "10,000–24,999 ft²",
                },
                {
                    id: "quote-size-25000-plus",
                    value: "25,000+ ft²",
                },
            ],
        },
    },
    fileUploadField: {
        label: "Floor Plans",
    },
    checkbox: {
        consent: {
            id: "quote-consent",
            label: "I agree to be contacted regarding this quote",
        },
    },
    textButton: {
        text: "Request My Quote",
        type: "primary",
    },
};
